// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { ValidationFailure } from "generated/mos/org/getty/validation";
import { Page } from "generated/mos/pagination";
import { BundleType, BundleTypeValues } from "generated/mos/releasecontrols";
import { Codec, DecodeContext, RemoteObject, WebRPCError, decodeMessageRepeated, ensureScalar, ensureScalarRepeated } from "generated/webrpc";

export namespace ListValidationFailuresRequest {
  export const refName = "mos.org.getty.validation_access.ListValidationFailuresRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly page: Page.Entity | undefined,
    readonly sortOrder: ListValidationFailuresRequest.SortOrder,
    readonly filter: ListValidationFailuresRequest.ByRef.Entity | ListValidationFailuresRequest.ByBundleType.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    page: undefined,
    sortOrder: "SORT_DEFAULT",
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["page"] = Page.codec.encode(v.page);
      obj["sortOrder"] = v.sortOrder;
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.validation_access.ListValidationFailuresRequest.ByBundleType") {
            obj["byBundleType"] = ListValidationFailuresRequest.ByBundleType.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.validation_access.ListValidationFailuresRequest.ByRef") {
            obj["byRef"] = ListValidationFailuresRequest.ByRef.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.validation_access.ListValidationFailuresRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.validation_access.ListValidationFailuresRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["page"] = ctx.decode(Page.codec, v["page"], "page");
      {
        const ev = ensureScalar(ctx, v["sortOrder"], "string") || defaults["sortOrder"];
        if (!ListValidationFailuresRequest.SortOrderValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.validation_access.ListValidationFailuresRequest.SortOrder`);
        }
        out["sortOrder"] = ev as any;
      }
      {
        if (v["byBundleType"] !== undefined) {
          out["filter"] = ctx.decode(ListValidationFailuresRequest.ByBundleType.codec, v["byBundleType"], "byBundleType");
        }
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListValidationFailuresRequest.ByRef.codec, v["byRef"], "byRef");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.validation_access.ListValidationFailuresRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly entityRefs: ReadonlyArray<{ readonly typename: string, readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      entityRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.validation_access.ListValidationFailuresRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["entityRefs"] = v["entityRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace ByBundleType {
    export const refName = "mos.org.getty.validation_access.ListValidationFailuresRequest.ByBundleType" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly bundleTypes: ReadonlyArray<BundleType>,
    }
    export const defaults: Entity = {
      type: refName,
      bundleTypes: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.validation_access.ListValidationFailuresRequest.ByBundleType");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        {
          const evs = ensureScalarRepeated(ctx, v["bundleTypes"], "string").map(i => i || defaults["bundleTypes"]);
          for (const ev of evs) {
            if (!BundleTypeValues.has(ev as any)) {
              throw ctx.error(`unknown value "${ev}" for enum .mos.release_controls.BundleType`);
            }
          }
          out["bundleTypes"] = evs as any;
        }
        return out as any as Entity;
      }
    }();
  }

  export const SortOrderValues = new Set([
    'SORT_DEFAULT' as const,
    'SORT_CREATED_AT_DESC' as const,
  ]);
  export type SortOrder = typeof SortOrderValues extends Set<infer U> ? U : never;

}

// The response will only contain entries for matching entities which have failed validation
export namespace ListValidationFailuresResponse {
  export const refName = "mos.org.getty.validation_access.ListValidationFailuresResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly failures: ReadonlyArray<ValidationFailure.Entity>,
    readonly nextPage: Page.Entity | undefined,
    readonly totalItems: number,
  }
  export const defaults: Entity = {
    type: refName,
    failures: [],
    nextPage: undefined,
    totalItems: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["failures"] = [];
      for (const item of v.failures) {
        obj["failures"].push(ValidationFailure.codec.encode(item));
      }
      obj["nextPage"] = Page.codec.encode(v.nextPage);
      obj["totalItems"] = v.totalItems;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.validation_access.ListValidationFailuresResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["failures"] = decodeMessageRepeated(ctx, ValidationFailure.codec, v["failures"], "failures");
      out["nextPage"] = ctx.decode(Page.codec, v["nextPage"], "nextPage");
      out["totalItems"] = ensureScalar(ctx, v["totalItems"], "number");
      return out as any as Entity;
    }
  }();
}

